export default {
  LOGS_LIST: "Liste des journaux",
};
